import { onUnmounted, readonly, ref } from 'vue'
import type { Ref } from 'vue'

/**
 * Relógio local do portal (o contrato B não manda serverNow). Um tique por tela; os
 * componentes recebem `nowMs` por prop.
 */
export function useNowTick(tickMs = 30_000): { nowMs: Readonly<Ref<number>> } {
  const nowMs = ref(Date.now())
  const timer = setInterval(() => {
    nowMs.value = Date.now()
  }, tickMs)
  onUnmounted(() => clearInterval(timer))
  return { nowMs: readonly(nowMs) }
}
